import React from 'react';
// import {Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import SideNavBar from './SideNavBar';


const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
  },
  noGutterLeft : {
    paddingLeft: '10px',
  }
}));

export default function NavBar() {
  const classes = useStyles();
  function toggleTheme() {
    document.querySelector('html').classList.toggle('dark');
  }

  return (
    <div>
      <AppBar position="static">
        <div className="col-12 flex center">
        <div className="col-12 col-md-10 col-lg-8">
        <Toolbar className={classes.noGutterLeft}>
          <Typography variant="h4" className={classes.title}>
            <span style={{"whiteSpace":"nowrap"}}>Umakant Vashishtha</span>
          </Typography>
          <div className="d-none d-lg">
            <div style={{'whiteSpace':'nowrap', display: 'flex', alignItems:' center'}}>
              
              <div className="ps-10 mr-10">
                <a href="#education">Education</a>
              </div>
              <div className="ps-10 mr-10">
                <a href="#skills">Skills</a>
              </div>
              <div className="ps-10 mr-10">
                <a href="#projects">Projects</a>
              </div>
              <div className="ps-10 mr-10">
                <a href="#contact">Contact</a>
              </div>
            </div>
          </div>
          <div className="d-lg-none mr-10" style={{marginRight: '5px'}}>
            <SideNavBar />
          </div>
        </Toolbar>
        </div>
        </div>
      </AppBar>
    </div>
  )
}